import { render, staticRenderFns } from "./responsible_unit.vue?vue&type=template&id=77b255c8&scoped=true&"
import script from "./responsible_unit.vue?vue&type=script&lang=js&"
export * from "./responsible_unit.vue?vue&type=script&lang=js&"
import style0 from "./responsible_unit.vue?vue&type=style&index=0&id=77b255c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b255c8",
  null
  
)

export default component.exports